export enum TargetType {
  INITIAL = 'initial',
  PHONE = 'phone',
}